import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/tdm/";

export default class TDMApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getTDMs(params) {
    return await request.post(`${rootRoute}getTDMs`, {
      filter: params,
      parameters: {},
    });
  }
  async getTDM(id) {
    return await request.post(`${rootRoute}getTDMs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createTDM(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createTDM`, { data });
  }
  async deleteTDM(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteTDM`, { data });
  }
  async editTDM(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateTDM`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importTDM`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getTDMimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportTDM`, {
      filter: filter,
      format: format
    });
  }
}
